import React , { useState ,useEffect  , useRef }  from "react";
import { PlusIcon, MinusIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";
import {
useCompanyQueryAnalysis , 
useCompanyQueryAdvdisadv,
} from 'data/company';
import {number_format,APP_URL} from 'components/config/Common';
import TradingViewGaugeECharts from 'components/company/TradingViewGaugeECharts';
import {DotIcon} from 'components/icons/dot-icon.tsx';
import {TickIcon} from 'components/icons/tick-icon.tsx';
import {CrossIcon} from 'components/icons/cross-icon.tsx';
import PercentChangeBox from 'components/ui/PercentChangeBox';

// import the component
//import ReactSpeedometer from "react-d3-speedometer"
// and just use it

export default function AnalysisSection({companyinfo,type}) {
     
const {
        technicalanalysis,
        isLoading: loading,
        error:errorindicescomp,
      } = useCompanyQueryAnalysis(companyinfo?.id);


const {
        advdisadvdata,
        isLoading: loadingadv,
        error:erroradvdisadv,
      } = useCompanyQueryAdvdisadv({id:companyinfo?.id,
        company_type:companyinfo?.company_type,
});

const performanceData = [
  { label: "1 Week", value: 'week_price_change' },
  { label: "1 Month", value: 'month_price_change' },
  { label: "6 Month", value: 'month6_price_change' },
  { label: "1 Year", value: 'month12_price_change' },
];

//console.log("advdisadvdata",advdisadvdata);

  return (
      <section className="bg-white shadow-md z-50 rounded-xl p-5">
        <h2 className="text-2xl font-semibold">Analysis</h2>
        <div className="flex w-full">
            <div className="w-8/12">
          {advdisadvdata?
            <div className="flex flex-col gap-y-10">
              <div>
                <h2 className="pb-4 text-xl font-medium flex space-x-2 items-center">
                  <div><TickIcon className="w-8 h-8"  color="#0fc746ff" />
                  </div>
                  <div>Positive Takeaways
                    </div>
                  </h2>
                
                <ul
                    className="flex min-h-20 flex-col items-start gap-2 rounded-lg border border-green-200  px-3 py-2 "
                >
                {advdisadvdata?.good?.map((item, index) => (
                  <li key={index}
                  className="flex space-x-3 items-center"
                  ><DotIcon className="w-8 h-8" color="#0fc746ff" />{item}</li>
                ))}
                </ul>
        
              </div>
              <div 
              >
              <h3 className="pb-4 text-xl font-medium flex space-x-2 items-center">
                <div>
                  <CrossIcon  className="w-8 h-8"  color="#d32f2f"  />
                </div>
                <div>Points of Caution</div></h3>
                <ul 
                  className="flex min-h-20 flex-col items-start gap-2 rounded-lg border border-red-200  px-3 py-2 "
                >
                {advdisadvdata?.bad?.map((item, index) => (
                  <li key={index}
                  className="flex space-x-3 items-center"
                  ><DotIcon className="w-8 h-8" color="#d32f2f" />{item}</li>
                ))}
                </ul>
              </div>
            </div>
            :
            <p className="mt-4">Analysis in progress.<br />
            Our team is preparing insights based on upcoming financial data. <br />Check back soon.</p>
            }
        </div>
        <div className="w-8/12">
        <div className=" mx-auto ">
         <h2 className="text-2xl font-semibold text-center">Price Trend</h2>
        
        <>{technicalanalysis?.week_price_change != null &&
  technicalanalysis?.month_price_change != null &&
  technicalanalysis?.month6_price_change != null &&
  technicalanalysis?.month12_price_change != null
                 ?
        <div className="flex gap-4 pb-10  justify-center flex-wrap">
        {performanceData.map((item) => (
          <div key={item.label}>
            <p className="text-xs mb-1 text-gray-500">{item.label}</p>
            <PercentChangeBox value={technicalanalysis[item.value]} />
          </div>
        ))}
      </div>
      :
      <p className="pb-10 text-center">Not data available yet.</p>
  }</>
      </div>
    {technicalanalysis?.score &&
    <div className="max-w-md mx-auto">
      <div className="flex flex-col items-center">
        <h2 className="text-2xl font-semibold">Technical</h2>
        <div>Score:{technicalanalysis?.score}</div>
      </div>
      <TradingViewGaugeECharts score={technicalanalysis?.score} signal_status={technicalanalysis?.stock_signal} />
    </div>  
  }
  </div>
  </div>
{/*<div className="w-full max-w-md mx-auto px-2">
          <ReactSpeedometer
    value={777}
    currentValueText="Happiness Level"
    segments={6}
    segmentColors={[
    "#d32f2f",
    "#f57c00",
    "#fbc02d",
    '#C0C0C0',
    "#7cb342",
    "#2e7d32",
  ]}
    customSegmentLabels={[
      {
        text: "Strong Bullish",
        position: "OUTSIDE",
        color: "#555",
      },
      {
        text: "Bullish",
        position: "OUTSIDE",
        color: "#555",
      },
      {
        text: "Mild Bullish",
        position: "OUTSIDE",
        color: "#555",
      },
      {
        text: "Neutral",
        position: "OUTSIDE",
        color: "#555",
      },
      {
        text: "Bearish",
        position: "OUTSIDE",
        color: "#555",
      },
      {
        text: "Strong Bearish",
        position: "OUTSIDE",
        color: "#555",
      },
    ]}
  />
      </div> */}
      
      </section> 
  );
}
